// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"385c60c3","77":"3967e649","119":"f02d67cc","267":"da0c2ae2","328":"2b8de234","383":"9947464e","409":"eea0cb07","464":"fc83e077","494":"ca8c216f","533":"758d92d1","708":"64b44021","728":"b7b7d39c","879":"c2e52f17","936":"1af05f88"}[chunkId] + ".chunk.js";
};